import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from "./../components/sidebar";
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';
import Alert from 'react-bootstrap/Alert';

const Lecciones = () => {
  const [lecciones, setLecciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentLeccion, setCurrentLeccion] = useState(null);
  const [formData, setFormData] = useState({
    nombreleccion: '',
    descripcion: '',
    urlvideo: '',
    duracion: '',
    idcurso: ''
  });
  const navigate = useNavigate();

  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Función reutilizable para obtener las lecciones
  const fetchLecciones = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://api.mrcirp.com/public/lecciones');
      setLecciones(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching lecciones:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLecciones();
  }, []);

  const handleEditClick = (leccion) => {
    setCurrentLeccion(leccion);
    setFormData({
      nombreleccion: leccion.nombreleccion,
      descripcion: leccion.descripcion,
      urlvideo: leccion.urlvideo,
      duracion: leccion.duracion,
      idcurso: leccion.idcurso
    });
    setShowEditModal(true);
  };

  const handleDeleteClick = (leccion) => {
    setCurrentLeccion(leccion);
    setShowDeleteModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 const handleUpdateLeccion = async () => {
  try {
    const response = await axios.put(
      `https://api.mrcirp.com/public/lecciones/${currentLeccion.id}`,
      formData
    );
    
    // Actualización local del estado (sin volver a cargar de la API)
    setLecciones(lecciones.map(leccion => 
      leccion.id === currentLeccion.id ? { ...leccion, ...formData } : leccion
    ));
    console.log(response.data);
    setShowEditModal(false);

  } catch (err) {
    console.error('Error updating lección:', err);
   
  }
};

 const handleDeleteLeccion = async () => {
  try {
    await axios.delete(`https://api.mrcirp.com/public/lecciones/${currentLeccion.id}`);
    
    // Eliminación local del estado (sin volver a cargar de la API)
    const updatedLecciones = lecciones.filter(leccion => leccion.id !== currentLeccion.id);
    setLecciones(updatedLecciones);
    
    // Ajustar la página actual si es necesario
    const newTotalPages = Math.ceil(updatedLecciones.length / itemsPerPage);
    if (currentPage > newTotalPages && newTotalPages > 0) {
      setCurrentPage(newTotalPages);
    }
    
    setShowDeleteModal(false);

  } catch (err) {
    console.error('Error deleting lección:', err);

  }
};

  // Funciones para paginación
  const totalPages = Math.ceil(lecciones.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentLecciones = lecciones.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) return (
    <Sidebar>
      <div className="container mt-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="mt-2">Cargando lecciones...</p>
      </div>
    </Sidebar>
  );
  
  if (error) return (
    <Sidebar>
      <div className="container mt-4">
        <Alert variant="danger">Error: {error}</Alert>
      </div>
    </Sidebar>
  );

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <Card>
            <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
              <span>Lecciones</span>
              <small className="text-muted">
                Mostrando {currentLecciones.length} de {lecciones.length} lecciones
              </small>
            </Card.Header>
            <Card.Body style={{ padding: '0.75rem' }}>
              {lecciones.length === 0 ? (
                <Alert variant="info" className="mb-0">No hay lecciones disponibles</Alert>
              ) : (
                <>
                  <div className="table-responsive" style={{ fontSize: '0.875rem' }}>
                    <Table striped bordered hover size="sm" className="mb-2">
                      <thead>
                        <tr>
                          <th style={{ width: '150px', padding: '0.5rem' }}>Nombre Curso</th>
                          <th style={{ width: '150px', padding: '0.5rem' }}>Módulo</th>
                          <th style={{ padding: '0.5rem' }}>Nombre Lección</th>
                          <th style={{ padding: '0.5rem', maxWidth: '250px' }}>Descripción</th>
                          <th style={{ width: '100px', padding: '0.5rem' }}>Video</th>
                          <th style={{ width: '100px', padding: '0.5rem' }}>Duración</th>
                          <th style={{ width: '150px', padding: '0.5rem' }}>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentLecciones.map((leccion) => (
                          <tr key={`${leccion.idcurso}-${leccion.nombreleccion}`}>
                            <td style={{ padding: '0.5rem' }}>{leccion.nombrecurso}</td>
                            <td style={{ padding: '0.5rem' }}>{leccion.nombremodulo}</td>
                            <td style={{ padding: '0.5rem', fontWeight: '500' }}>{leccion.nombreleccion}</td>
                            <td style={{ padding: '0.5rem' }}>
                              <div style={{ 
                                maxWidth: '250px', 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }} title={leccion.descripcion}>
                                {leccion.descripcion}
                              </div>
                            </td>
                            <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                              {leccion.urlvideo ? (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  href={leccion.urlvideo}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                >
                                  Ver Video
                                </Button>
                              ) : (
                                <span className="text-muted" style={{ fontSize: '0.75rem' }}>No disponible</span>
                              )}
                            </td>
                            <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                              {leccion.duracion ? `${leccion.duracion} min` : '-'}
                            </td>
                            <td style={{ padding: '0.5rem' }}>
                              <div className="d-flex flex-wrap gap-1">
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  onClick={() => handleEditClick(leccion)}
                                  style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                >
                                  Editar
                                </Button>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleDeleteClick(leccion)}
                                  style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                >
                                  Eliminar
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-3">
                      <Pagination>
                        <Pagination.First 
                          onClick={() => handlePageChange(1)} 
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev 
                          onClick={() => handlePageChange(currentPage - 1)} 
                          disabled={currentPage === 1}
                        />
                        {[...Array(totalPages)].map((_, index) => {
                          const page = index + 1;
                          // Mostrar solo algunas páginas alrededor de la actual
                          if (
                            page === 1 ||
                            page === totalPages ||
                            (page >= currentPage - 2 && page <= currentPage + 2)
                          ) {
                            return (
                              <Pagination.Item
                                key={page}
                                active={page === currentPage}
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </Pagination.Item>
                            );
                          } else if (
                            page === currentPage - 3 ||
                            page === currentPage + 3
                          ) {
                            return <Pagination.Ellipsis key={page} />;
                          }
                          return null;
                        })}
                        <Pagination.Next 
                          onClick={() => handlePageChange(currentPage + 1)} 
                          disabled={currentPage === totalPages}
                        />
                        <Pagination.Last 
                          onClick={() => handlePageChange(totalPages)} 
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </Sidebar>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Lección</h5>
                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Nombre de la Lección</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombreleccion"
                      value={formData.nombreleccion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Descripción</label>
                    <textarea
                      className="form-control"
                      name="descripcion"
                      value={formData.descripcion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">URL del Video</label>
                    <input
                      type="text"
                      className="form-control"
                      name="urlvideo"
                      value={formData.urlvideo}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Duración (minutos)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="duracion"
                      value={formData.duracion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">ID del Curso</label>
                    <input
                      type="text"
                      className="form-control"
                      name="idcurso"
                      value={formData.idcurso}
                      onChange={handleInputChange}
                      disabled
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleUpdateLeccion}>
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmar Eliminación</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar la lección "{currentLeccion?.nombreleccion}"?</p>
                <p className="text-danger">Esta acción no se puede deshacer.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteLeccion}>
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Lecciones;